var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeResponsive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#912B9A",
    d: "M12.557 13.625c-1.355 0-2.676-.302-3.963-.906A12.014 12.014 0 0 1 2.78 6.905c-.603-1.287-.905-2.607-.905-3.962 0-.19.063-.347.189-.473a.641.641 0 0 1 .472-.19H5.09c.147 0 .278.048.394.143a.554.554 0 0 1 .204.362l.41 2.206c.021.147.018.28-.008.402a.645.645 0 0 1-.181.323L4.395 7.26c.442.756.993 1.465 1.655 2.127a11.53 11.53 0 0 0 2.19 1.717l1.48-1.481a.883.883 0 0 1 .371-.213c.152-.047.302-.06.45-.04l2.174.442a.64.64 0 0 1 .362.213c.095.11.142.239.142.386v2.552a.641.641 0 0 1-.19.473.641.641 0 0 1-.472.189z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B16AB8",
    d: "M4.397 7.263c.441.755.992 1.463 1.653 2.124.66.66 1.39 1.232 2.187 1.715l.002.002-.84.972a11.95 11.95 0 0 1-2.223-1.752A11.952 11.952 0 0 1 3.47 8.177l.925-.917.002.003zM14.352 4.227h-3.5v3.5l1.093-2.406 2.407-1.094z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEBFE0",
    d: "M14.352 4.227h-3.5v-3.5l1.093 2.406 2.407 1.094z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#82278A",
    d: "M7.352 4.227h3.5v3.5L9.758 5.321 7.352 4.227z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B16AB8",
    d: "M7.352 4.227h3.5v-3.5L9.758 3.133 7.352 4.227z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C894CC",
    d: "M3.268 10.06l.73 1.605 1.604.729-1.605.729-.729 1.604-.729-1.604-1.604-.73 1.604-.728.73-1.605z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeResponsive);
export default __webpack_public_path__ + "static/media/BadgeResponsive.1004ed496a888f465d96b2bf09a633d5.svg";
export { ForwardRef as ReactComponent };